import React, { useState, useEffect } from "react";

import {
    Box,
    Button,
    TextField,
    Grid,
    styled,
    Card,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText
} from '@mui/material';

import { useFormik } from 'formik';

import CommonSectionHeader from "../../../common/CommonSectionHeader"
import { useAppContextFeatures } from '../../../../context/AppContext';

import { useSettings, defaultTypes, defaultSettings, getCreatePayload, getListFilters } from "../../../../hooks/api/useSettings";
import { useTranslations } from '../../../../hooks/useTranslations';
import { useSystemPrompt } from "../../../../hooks/useSystemPrompt";

import { initialValues, validationSchema } from '../../../../schema/setting/email/defaultSchema'

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

const selectionSettingKeys = [
    defaultSettings.sms_gateway.isms.key,
]

const RenderForm = ({
    t,
    values,
    handleChange,
    errors,
    touched,
}) => {
    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={3} sx={{ mt: 1 }}>
                <CommonSectionHeader
                    title={"Setting Key"}
                />
            </Grid>

            <Grid item xs={12} sm={12} md={9}>
                <FormControl
                    margin="dense"
                    fullWidth
                    size="small"
                    error={touched.type && Boolean(errors.type)}
                >
                    <InputLabel id="type">{t('settingKey')}</InputLabel>
                    <Select
                        // labelId="type"
                        label={t("settingKey")}
                        name={"settingKey"}
                        onChange={handleChange}
                        value={values.settingKey}
                        sx={{
                            textAlign: 'left'
                        }}
                    >
                        {
                            selectionSettingKeys.map((i, index) => {
                                return (
                                    <MenuItem key={index} value={i}>{i}</MenuItem>
                                )
                            })
                        }
                    </Select>
                    <FormHelperText>
                        {touched?.settingKey && errors?.settingKey}
                    </FormHelperText>
                </FormControl>
            </Grid>

        </Grid>
    )
}

export default function DefaultSetting({
    routeType
}) {

    const { t } = useTranslations({ ns: ["common", "@user", "sidebar"] })

    const { promptMessage } = useSystemPrompt();
    const { setSystemLoading } = useAppContextFeatures()

    const { create, list } = useSettings(defaultTypes.sms_gateway.id);

    // const navigate = useNavigate();
    // const { getRoute } = useSystemRoutes(routeType);
    // const { getHtmlHead } = useSystemHead(routeType)
    const [savedValues, setSavedValues] = useState(initialValues)

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            let propsData = [
                {
                    // key: defaultSettings.email_gateway.default.props.settingKey,
                    key: defaultSettings.sms_gateway.default.props.settingKey,
                    value: currentValues.settingKey,
                    label: "Selected Setting Key"
                }
            ]

            let loadInfo = getCreatePayload({
                typeId: defaultTypes.sms_gateway.id,
                typeName: "",
                settingId: defaultSettings.sms_gateway.default.id,
                settingName: '',
                props: propsData
            })

            let data = {
                settings: [loadInfo]
            }

            const response = await create({ data });

            console.log("Data", response)

            promptMessage(true, `${response?.message}`)

            // navigate(getRoute("settings"))

        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const fetchSetting = async () => {

        setSystemLoading(true)

        try {

            let filterValues = getListFilters({
                typeKey: defaultTypes.sms_gateway.key,
                settingKey: defaultSettings.sms_gateway.default.key,
                // settingKeys: [],
                fieldKeys: [
                    defaultSettings.sms_gateway.default.props.settingKey,
                ]
            })

            const props = {
                limit: -1,
                skip: 0,
                filterValue: filterValues,
                sortInfo: {
                    id: "id",
                    dir: -1
                },
            }

            const response = await list(props);

            // console.log("Data", response)

            if (response?.data?.settings) {
                let savedSettings = response.data.settings

                let _selectedSettingKey = ""

                savedSettings.forEach(i => {
                    if (i.field_key === defaultSettings.sms_gateway.default.props.settingKey) {
                        _selectedSettingKey = i.field_value
                    }
                })

                setSavedValues({
                    ...initialValues,
                    settingKey: _selectedSettingKey,
                })
            }

        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const formik = useFormik({
        initialValues: savedValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    useEffect(() => {

        fetchSetting()

    }, [])

    return (
        <form onSubmit={formik.handleSubmit}>
            <StyledCard>

                <RenderForm
                    t={t}
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    touched={touched}
                />

            </StyledCard>
            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                <Grid item md={12} textAlign={"right"}>
                    <Button
                        type="submit"
                        variant="contained"
                        sx={{
                            mt: 3,
                            mb: 2
                        }}
                    >
                        {t('saveChanges')}
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}